import { useNuxtApp } from "#app";

export function isInitialClientLoad () {
  const nuxtApp = useNuxtApp();
  return import.meta.client && nuxtApp.isHydrating && nuxtApp.payload.serverRendered;
}
